import { message } from 'antd';

export const popIn = (type, body, duration = 15) => {
	return message[type](body, duration);
};
